import { createContext, useContext } from 'react'

interface RadioGroupContextType {
  value: string
  onChange?: (value: string) => void
  name?: string
}

export const RadioGroupContext = createContext<RadioGroupContextType | null>(null)

export const useRadioGroup = () => {
  return useContext(RadioGroupContext)
}
